<template>
  <b-modal
    id="AddUser"
    @keyup.enter="edit? editUser():addUser()"
    hide-footer
    :title="edit ? $t('users.editUser') : $t('users.addUser')"
    >
    <b-form>
        <bigCheck class="pt-4" :state="state"></bigCheck>
        <div v-show="state==='unloaded'">
          <v-field field="email"  :label="$t('login.email')" type="email" :msg="errorMsgs" ref="email" :val="edit? user.email: ''"></v-field>
          <b-row>
            <b-col lg='6' v-show="!edit">
              <v-field field="password" :label="$t('login.password')" type="password" :msg="errorMsgs" ref="password"></v-field>
            </b-col>
            <b-col lg='6' v-show='!edit'>
              <v-field field="password2" :label="$t('login.rep_newpass')" type="password" :msg="errorMsgs" ref="password2"></v-field>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg='6'>
              <v-field field="first_name" :label="$t('labels.firstName')" type="text"  :msg="errorMsgs" ref="first_name" :val="edit? user.first_name: ''"></v-field>
            </b-col>
            <b-col lg='6'>
              <v-field field="last_name" :label="$t('labels.lastName')"  type="text"  :msg="errorMsgs" ref="last_name" :val="edit? user.last_name: ''"></v-field>
            </b-col>
          </b-row>
          <v-field field="is_active" :label="$t('labels.isActive')" type="checkbox" :msg="errorMsgs" ref="is_active" :val="edit? user.is_active: false"></v-field>
          <div class="form-group">
            <label>{{$t('labels.typeUser')}}:</label>
            <Multiselect v-model="groupSelected"
                        :options="groupOptions"
                        track-by="id"
                        :multiple="true"
                        :preselectFirst="true"
                        label="name"
                        >
            </Multiselect>
          </div>
          <p v-show="getErrors('non_field_errors')!==''" class="alert alert-danger feedback-message">
              {{getErrors('non_field_errors')}}
          </p>
        </div>
        <div
          class="text-right mt-2"
          slot="footer">
            <b-btn @click="clear" :variant="this.state === 'unloaded' ? 'outline-primary':'primary'">
              {{$t('users.saveUserOther')}}
            </b-btn>
            <b-btn v-if="this.state === 'unloaded'" @click="edit ? editUser():addUser()" variant="primary">
              <span>{{$t('users.saveUser')}}<i class="fa fa-check"></i></span>
            </b-btn>
        </div>
    </b-form>
  </b-modal>
</template>

<script>
import FormField from '@/components/Pages/Users/FormField';
import bigCheck from '@/components/Modules/Misc/bigCheck';

export default {
  name: 'UserForm',
  components: {
    'v-field': FormField,
    bigCheck
  },
  computed: {
    edit () {
      return Object.keys(this.user).length;
    }
  },
  methods: {
    getErrors: function (col) {
      try {
        let out = this.errorMsgs[col].join(' ');

        return out;
      } catch (err) {
        return '';
      }
    },
    clearFormFields: function () {
      let columns = this.$refs;
      for (let i in columns) {
        let col = columns[i];
        col.reset();
      }
    },
    clear: function () {
      this.state = 'unloaded';
      this.$emit('clearUser');
      this.clearFormFields();
      this.errorMsgs = '';
    },
    _fail_response: function (body) {
      this.state = 'unloaded';
      this.errorMsgs = body;
    },
    _sucess_response: function (body) {
      this.state = 'loaded';

      this.$emit('refreshUsers');
      this.$emit('clearUser');
      this.clearFormFields();

      this.errorMsgs = body;
    },
    _get_data_form: function () {
      if (this.state === 'loaded') {
        this.state = 'unloaded';
        return;
      }

      this.state = 'loading';

      let data = {};
      let columns = this.$refs;
      for (let i in columns) {
        let col = columns[i];
        data[i] = col.compValue;
      }
      return data;
    },
    addUser: function () {
      let data = this._get_data_form();

      if (this.groupSelected) { data['groups'] = this.groupSelected.map(x => x.id); }
      this.$http.post('createuser/', data).then(
        response => {
          this._sucess_response(response.body);
        },
        response => {
          this._fail_response(response.body);
        }
      );
    },
    editUser: function () {
      let data = this._get_data_form();

      data['groups'] = this.groupSelected;
      this.$http.put('users/' + this.user.id + '/', data).then(
        response => {
          this._sucess_response(response.body);
        },
        response => {
          this._fail_response(response.body);
        }
      );
    },
    getGroups: function () {
      this.$http.get('groups/').then(response => {
        this.groupOptions = response.body;
        this.groupSelected = [this.groupOptions[0]];
      });
    }
  },
  mounted () {
    this.getGroups();
  },
  data () {
    return {
      groupSelected: [],
      groupOptions: [],
      state: 'unloaded',
      errorMsgs: '',
      user: ''

    };
  },
  watch: {
    userTable: function () {
      this.user = this.userTable;
      if (this.userTable.groups) {
        this.groupSelected = this.userTable.groups;
      } else { this.groupSelected = [this.groupOptions[0]]; }
    }
  },
  props: ['userTable', 'user_id']
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Users/UserForm.vue